import React from "react"

import classNames from "classnames"

import { WithChildren } from "shared/types/WithChildren"
import { WithClassName } from "shared/types/WithClassName"
import { Skeleton } from "shared/ui/skeleton/Skeleton"

import { Icon } from "../icon/Icon"
import { IconName } from "../icon/__generated__/IconName"
import "./styles/_image.scss"

export interface ImageListProps extends WithClassName, WithChildren {
  isLoading?: boolean
}

export const ImageList = React.memo(
  ({ children, isLoading, className }: ImageListProps) => (
    <div
      className={classNames(
        "image-list",
        { "image--loading": isLoading },
        className
      )}
    >
      <div className="image-list__content">{children}</div>
      {isLoading ? <Skeleton containerClassName="image-list__loader" /> : null}
      <div className="image-list__empty">
        <Icon name={IconName.NO_IMAGE} />
      </div>
    </div>
  )
)
